import { Injectable } from '@angular/core';

type ValuesOptions<T> = {
  filter?: (value: unknown, property: keyof T) => boolean;
};

class ObjectEntriesBuilder<T extends object> {
  private result: Partial<T>;

  constructor(obj: T) {
    this.result = { ...obj };
  }

  filter(predicate: (value: unknown, property: keyof T) => boolean): this {
    Object.keys(this.result).forEach((property) => {
      const key = property as keyof T;

      if (!predicate(this.result[key], key)) {
        delete this.result[key];
      }
    });

    return this;
  }

  public exclude(properties: (keyof T)[]): this {
    properties.forEach((property) => {
      delete this.result[property];
    });

    return this;
  }

  public value<R>(selector: (value: unknown, property: keyof T) => R): this {
    Object.keys(this.result).forEach((property) => {
      const key = property as keyof T;
      (this.result as any)[key] = selector(this.result[key], key);
    });

    return this;
  }

  public stringify(options?: {
    removePropertyQuotes?: boolean;
    propertiesSeparator?: string;
  }): string {
    let result = JSON.stringify(this.result);

    if (options?.removePropertyQuotes) {
      result = result.replace(/"([^"]+)":/g, '$1:');
    }

    if (options?.propertiesSeparator) {
      result = result.replace(/,/g, '|');
    }

    return result;
  }
}

@Injectable({ providedIn: 'root' })
export class ObjectUtilsService {
  public entries<T extends object>(obj: T): ObjectEntriesBuilder<T> {
    return new ObjectEntriesBuilder(obj);
  }
}
